module.exports = __webpack_public_path__ + "img/chinesecompany124.54fe1ce6.png";